module.exports = __webpack_public_path__ + "static/media/galdisa_blogImg5.a31de4e3.jpg";